// ToggleableConsentGroup.js
import React, { Fragment } from 'react';
import { Field } from 'react-final-form-html5-validation'; 

class ToggleableConsentGroup extends React.Component {
  handleChange = (value, inputOnChange) => {
    const { selectedValue, onChange, questionAnswer } = this.props;
    
    // Toggle off if already selected; else set new value
    const newValue = selectedValue === value ? null : value;

    // Pass new value up to parent
    onChange(newValue);

    // Also call questionAnswer
    questionAnswer("consent", newValue);

    inputOnChange(newValue); //notify the form library
  };

  render() {
    const { selectedValue } = this.props;

    return (
      <div className="col pl-0">
        <div className="radio-field">
          <Field name="consent">
            {({ input, meta }) => (
              <Fragment>
                <input
                  id="iconsent"
                  name="consent"
                  type="radio"
                  checked={selectedValue === 'iconsent'}
                  onClick={() => this.handleChange('iconsent', input.onChange)}
                />
              </Fragment>
            )}
          </Field>
          <label htmlFor="iconsent">I consent</label>
        </div>

        <div className="radio-field">
          <Field name="consent">
            {({ input, meta }) => (
              <Fragment>
                <input
                  id="idonotconsent"
                  name="consent"
                  type="radio"
                  checked={selectedValue === 'idonotconsent'}
                  onClick={() => this.handleChange('idonotconsent', input.onChange)}
                />
              </Fragment>
            )}
          </Field>
          <label htmlFor="idonotconsent">I do not consent</label>
        </div>

        {/* hidden field to keep value in form data */}
        <Field name="consent" component="input">
          {({ input, meta }) => (
            <Fragment>
              <input
                {...input}
                type="text"
                value={selectedValue || ''}
                className="form-control full-width-input hidden-field"
                tabIndex="-1"
                readOnly
              />
              {meta.error && meta.touched && meta.error}
            </Fragment>
          )}
        </Field>
      </div>
    );
  }
}

export default ToggleableConsentGroup;
